/**
 * CheckboxSelectedIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CheckboxSelectedIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20 2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-2 7.17-7.07 7.07a1 1 0 0 1-.71.3 1 1 0 0 1-.7-.3L6 12.71a1 1 0 1 1 1.41-1.42l2.83 2.83 6.36-6.36A1 1 0 0 1 18 9.17" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const CheckboxSelectedIcon = makeIcon('CheckboxSelectedIcon', CheckboxSelectedIconSvg)
